// extracted by mini-css-extract-plugin
export default {"content":"PricingTableModal_content__myJhU","cards":"PricingTableModal_cards__B+afM"};